<template>
  <el-dialog
    title="物资申请审批"
    :visible.sync="visible"
    label-width="80px"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="mini"
    >
      <el-form-item label="物资明细">
        <el-table border :data="model.items" size="mini">
          <el-table-column label="物资类型" width="100" align="center">
            <template slot-scope="scope">
              {{ ApplyItemCategoryMap[scope.row.category] }}
            </template>
          </el-table-column>
          <el-table-column label="物资名称" align="center">
            <template slot-scope="scope">
              {{
                scope.row.product_template.name || scope.row.item_template.name
              }}
            </template>
          </el-table-column>
          <el-table-column label="申请数量" prop="quantity" align="center">
          </el-table-column>
          <el-table-column label="选择物资" min-width="120">
            <template slot-scope="scope">
              <ProductMultipleSelect
                v-if="scope.row.product_template_id"
                :templateId="scope.row.product_template_id"
                v-model="scope.row.material_ids"
              ></ProductMultipleSelect>
              <ItemSelect
                v-if="scope.row.item_template_id"
                :templateId="scope.row.item_template_id"
                v-model="scope.row.material_ids"
              ></ItemSelect>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item></el-form-item>
      <el-form-item label="审批结果" prop="pass">
        <el-radio-group v-model="model.pass">
          <el-radio :label="true">通过</el-radio>
          <el-radio :label="false">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审批备注" prop="remark">
        <el-input
          v-model="model.remark"
          placeholder="选填"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { applyApprove } from '@/service/getData'
import { ApplyItemCategoryMap } from '@/config/global'
import ItemSelect from '../../components/select/item_multiple_select.vue'

export default {
  components: { ItemSelect },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      ApplyItemCategoryMap,
      visible: this.show,
      rules: {
        pass: [
          { required: true, message: '请选择审批结果', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await applyApprove(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
            this.visible = false
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>